import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { MediasPageResponse } from 'types/media';
import mediaQueryKeys from './mediaQueryKeys';

export const useListMediasQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of medias
  // - just get ALL medias+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = mediaQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<MediasPageResponse, Error>(
    queryKey,
    () =>
      sdk.media.query.medias(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListMediasQuery;
